import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { vehicleIdentification } from "../utilities/vehicleIdentification";
import { DeviceActivityIcon, deviceActivityLabel } from "@/components/DeviceActivityIcon";
import { DeviceWithVehicleInfo } from "@/models/DeviceWithVehicleInfo";
import VinDetail from "@/models/VinDetail";
import { DeviceActivity } from "@/utilities/deviceActivity";

/** What the vehicle is, so the checklist below it can be read on its own. */
export function VehicleIdentification({
  device,
  vin,
  activity,
}: {
  device?: DeviceWithVehicleInfo | null;
  vin?: VinDetail;
  /** Whether the vehicle is moving right now; left out where no vehicle is selected. */
  activity?: DeviceActivity;
}) {
  const { t } = useTranslation();
  const fields = vehicleIdentification(
    device,
    t,
    t("liveData.checklist.notFound"),
    vin,
  );

  return (
    <Paper variant="outlined" sx={{ mb: 1.5, borderRadius: 1, px: 1.5, py: 1, flexShrink: 0 }}>
      <Stack direction="row" spacing={3} flexWrap="wrap" useFlexGap>
        {activity && (
          <Box>
            <Typography variant="caption" color="text.secondary" component="div">
              {t("liveData.checklist.activity")}
            </Typography>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <DeviceActivityIcon activity={activity} />
              <Typography variant="body2">{deviceActivityLabel(activity, t)}</Typography>
            </Stack>
          </Box>
        )}
        {fields.map(field => (
          <Box key={field.label}>
            <Typography variant="caption" color="text.secondary" component="div">
              {field.label}
            </Typography>
            <Typography variant="body2">{field.value}</Typography>
          </Box>
        ))}
      </Stack>
    </Paper>
  );
}
